// extracted by mini-css-extract-plugin
export var cta = "what-sauna-results-module--cta--9200a";
export var next = "what-sauna-results-module--next--80558";
export var prev = "what-sauna-results-module--prev--048ad";
export var result = "what-sauna-results-module--result--1a229";
export var resultContent = "what-sauna-results-module--resultContent--7a1bf";
export var resultImage = "what-sauna-results-module--resultImage--12541";
export var results = "what-sauna-results-module--results--c4250";
export var resultsWrapper = "what-sauna-results-module--resultsWrapper--76cf6";
export var section = "what-sauna-results-module--section--9fe1a";